import React from 'react'
import Reviews from '../../../components/Front/Reviews/Reviews'
import OnlineSkolaBgImage from '../../../assets/images/front/online-skola-bg.png'
import OnlineSkolaBgImageMobile from '../../../assets/images/front/online-skola-bg-mobile.png'
import HandImage from '../../../assets/images/front/ruka.png'
import ArrowRightWhite from '../../../assets/images/front/svg/arrow-right-white.svg'
import ArrowRightBlue from '../../../assets/images/front/svg/arrow-right-blue.svg'
import ArrowRightGreen from '../../../assets/images/front/svg/arrow-right-green.svg'
import SkolaBannerSecondary from '../../../assets/images/front/skola-banner-secondary.png'
import SkolaBannerSecondaryMobile from '../../../assets/images/front/skola-banner-secondary-mobile.png'
import AnglictinaImage from '../../../assets/images/front/svg/anglictina.svg'
import MatematikaImage from '../../../assets/images/front/svg/matematika.svg'
import CeskyImage from '../../../assets/images/front/svg/cesky.svg'
import PrijimackyImage from '../../../assets/images/front/svg/prijimacky.svg'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'

const OnlineSchool: React.FC = () => {
  const history = useHistory()

  return (
    <>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px]">
        <div className="relative w-full mx-auto">
          <img
            src={OnlineSkolaBgImage}
            alt=""
            className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
          />
          <img
            src={OnlineSkolaBgImageMobile}
            alt=""
            className="block w-full md:hidden rounded-b-3xl"
          />
          <div className="w-[calc(100%-32px)] lg:w-auto absolute left-4 lg:left-30 bottom-12">
            <span
              onClick={() => history.push(routesURLs.onlineCourses)}
              className="cursor-pointer relative block text-center text-[35px] lg:text-[48px] text-white bg-[#A8CD00] transition-colors duration-300 hover:bg-[#8FB200] pt-3 py-2 px-4 lg:px-8 rounded-lg lg:rounded-3xl w-full lg:w-auto"
            >
              vyzkoušet kurz zdarma
              <img
                src={HandImage}
                alt=""
                className="absolute right-[50%] translate-x-[50%] md:translate-x-0 -bottom-12 lg:-right-[50px] lg:-bottom-[65px] w-20 h-20 lg:w-[115px] lg:h-auto"
              />
            </span>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 px-4 md:px-0 mx-auto my-[30px] lg:my-[50px] max-w-[720px]">
          <div className="col-span-12 sm:col-span-6 flex flex-col items-start">
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start">
                <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
                kompletní učivo podle osnov ZŠ
              </li>
              <li className="flex items-start">
                <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
                výkladová videa
              </li>
              <li className="flex items-start">
                <img src={ArrowRightBlue} alt="" className="mt-1 me-1" />
                <span>
                  <strong>interaktivní cvičení</strong> s vyhodnocením nanečisto
                </span>
              </li>
              <li className="flex items-start">
                <img src={ArrowRightBlue} alt="" className="mt-1 me-1" /> materiály na procvičení
                probíraného učiva
              </li>
            </ul>
          </div>
          <div className="col-span-12 sm:col-span-6 flex flex-col items-start">
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start">
                <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                <span>
                  zpětná vazba pro rodiče <strong>každý týden</strong>
                </span>
              </li>
              <li className="flex items-start">
                <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                příjemní a zkušení učitelé
              </li>
              <li className="flex items-start">
                <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                platnost zakoupeného kurzu celý školní rok
              </li>
              <li className="flex items-start">
                <img src={ArrowRightGreen} alt="" className="mt-1 me-1" />
                <span>
                  první 3 lekce v každém kurzu <strong>zdarma</strong>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mb-[30px] lg:mb-[50px] px-4 lg:px-0">
          <div className="col-span-12 lg:col-span-8">
            <div className="aspect-W-16 aspect-h-9 h-full w-full rounded-3xl overflow-hidden shadow-lg">
              <iframe
                src="https://player.vimeo.com/video/1003097593"
                title="Online škola video"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 py-6 px-8 bg-[#00A0E3] rounded-3xl text-white">
            <h3 className="text-white text-lg lg:text-[25px] leading-tight mb-5">
              S ČÍM VÁM ON-LINE ŠKOLA POMŮŽE?
            </h3>
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start mb-1">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                zlepšování svých znalostí a dovedností
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                doplnění zameškaného učiva
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                průběžná příprava do školy
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                náhrada za klasické doučování
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                příprava na přijímací zkoušky
              </li>
              <li className="flex items-start">
                <img src={ArrowRightWhite} alt="" className="mt-1 me-1" />
                pochopení a procvičení látky
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container relative mx-auto md:px-4">
        <img src={SkolaBannerSecondary} alt="" className="hidden md:block rounded-3xl" />
        <img src={SkolaBannerSecondaryMobile} alt="" className="block md:hidden rounded-3xl" />
        <div className="grid grid-cols-12 gap-4 absolute top-5 left-8 pe-8 md:left-12">
          <div className="col-span-12 md:col-span-9 lg:col-span-6 flex flex-col">
            <h3 className="text-[25px] text-[#0183BA] mb-3 md:mb-2">
              VYZKOUŠEJTE SI ON-LINE KURZY ZDARMA
            </h3>
            <div className="mb-6 md:mb-3 leading-tight">
              <p className="mb-4 md:mb-3">
                Vyberte si kurz a přidejte do košíku lekce označené „Po registraci zdarma“. <br />
                Stačí pak jen vyplnit krátkou registraci a lekce se vám okamžitě zpřístupní.
              </p>
              <p>
                🎯 Vyzkoušejte si kurz naplno a zjistěte, jestli vám sedí. <br />
                📚 Pokud ano, můžete si kdykoliv dokoupit celý kurz nebo jen vybrané lekce.
              </p>
            </div>
            <span
              onClick={() => history.push(routesURLs.onlineMockExamCourses)}
              className="inline-block text-white leading-tight text-[25px] bg-[#00A0E3] rounded-xl pt-3 py-2 px-4 transition-colors duration-200 mx-auto md:ms-auto md:me-10"
            >
              vyzkoušet kurz zdarma
            </span>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 my-[30px] lg:my-[50px]">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-6">
            <span
              onClick={() => history.push(routesURLs.onlineCourses + '/2')}
              className="cursor-pointer text-xl lg:text-5xl text-white rounded-xl border bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 border-[#A8CD00] ps-24 pe-4 py-2 flex items-center w-full"
              style={{
                backgroundImage: `url(${MatematikaImage})`,
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '80px'
              }}
            >
              Matematika
            </span>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <span
              onClick={() => history.push(routesURLs.onlineCourses + '/3')}
              className="cursor-pointer text-xl lg:text-5xl text-white rounded-xl border bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 border-[#A8CD00] ps-24 pe-4 py-2 flex items-center w-full"
              style={{
                backgroundImage: `url(${CeskyImage})`,
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '80px'
              }}
            >
              Český jazyk
            </span>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <span
              onClick={() => history.push(routesURLs.onlineCourses + '/4')}
              className="cursor-pointer text-xl lg:text-5xl text-white rounded-xl border bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 border-[#A8CD00] ps-24 pe-4 py-2 flex items-center w-full"
              style={{
                backgroundImage: `url(${AnglictinaImage})`,
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '80px'
              }}
            >
              Angličtina
            </span>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <span
              onClick={() => history.push(routesURLs.personalTests)}
              className="cursor-pointer text-xl lg:text-5xl text-white rounded-xl border bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 border-[#A8CD00] ps-24 pe-4 py-2 flex items-center w-full"
              style={{
                backgroundImage: `url(${PrijimackyImage})`,
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '80px'
              }}
            >
              přijímačky nanečisto
            </span>
          </div>
        </div>
      </div>
      <div className="-mb-12">
        <div className="HP">
          <Reviews />
        </div>
      </div>
    </>
  )
}

export default OnlineSchool
